// extracted by mini-css-extract-plugin
export var cardIcon = "_5w-5";
export var checkboxCard = "_5w-0";
export var checkboxCardSelected = "_5w-4";
export var disabled = "_5w-2";
export var interactive = "_5w-1";
export var outerBorder = "_5w-3";
export var spacerMedium = "_5w-8";
export var spacerSmall = "_5w-7";
export var spacerXsmall = "_5w-6";